// utils/exportAllTransactionsStyled.js
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

function formatDateDDMMM(dateString) {
  const options = { day: "2-digit", month: "short" };
  return new Date(dateString).toLocaleDateString("en-GB", options).replace(" ", "-");
}

export async function exportAllTransactionsFormattedToXLSX(transactions, accountCodes) {
  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet("AllTransactions");

  const headerTitles = ["TANGGAL", "NAMA PERKIRAAN", "KETERANGAN", "KODE", "DEBIT", "KREDIT"];
  sheet.addRow(headerTitles);

  // Styling header row
  const headerRow = sheet.getRow(1);
  headerRow.eachCell((cell) => {
    cell.font = { bold: true };
    cell.alignment = { vertical: "middle", horizontal: "center" };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFD966" }, // Kuning
    };
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
  });

  // Body rows
  transactions.forEach((tx, index) => {
    const account = accountCodes.find((ac) => ac.id === tx.account_code_id);
    const namaPerkiraan = account?.name || "-";
    const row = sheet.addRow([
      formatDateDDMMM(tx.transaction_date),
      namaPerkiraan,
      tx.description || "-",
      tx.account_code || "-",
      tx.transaction_type === "debit" ? tx.amount : "",
      tx.transaction_type === "credit" ? tx.amount : "",
    ]);

    // Belang-belang row coloring
    const fillColor = index % 2 === 0 ? "FFFFFF" : "F2F2F2";
    row.eachCell((cell, colNumber) => {
      cell.alignment = { vertical: "middle", horizontal: colNumber >= 5 ? "right" : "left" };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: fillColor },
      };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
      if (colNumber === 5 || colNumber === 6) {
        cell.numFmt = '"Rp" #,##0';
      }
    });
  });

  // Set column widths
  sheet.columns = [
    { width: 12 },
    { width: 25 },
    { width: 45 },
    { width: 10 },
    { width: 15 },
    { width: 15 },
  ];

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, `all_transactions_${new Date().toISOString().slice(0, 10)}.xlsx`);
}
